import { useParams } from '@uhg-abyss/web/tools/reactRouterTools';
import { Documentation } from '../Documentation/Documentation';
import { DocumentationV3 } from '../DocumentationV3/DocumentationV3';
import { config } from '@uhg-abyss/web/tools/config';
import React, { useEffect } from 'react';
export const DocumentationHandler = () => {
  const { service, slug } = useParams();

  useEffect(() => {
    // Dynatrace page tagging
    const dtrum = window?.dtrum;
    if (dtrum) {
      const pageName = slug
        ? `apimarketplace:documentation-${service}-${slug}`
        : `apimarketplace:documentation-${service}`;
      dtrum.setPage({
        name: pageName,
        group: `apimarketplace-${config('APP_ENV')}`,
      });
    }
  }, [service, slug]);

  const isSuperconnector =
    service === 'superconnector' || service === 'provideraccess';

  if (isSuperconnector) {
    return <DocumentationV3 />;
  }

  return <Documentation />;
};
